module.exports = __webpack_public_path__ + "static/img/service.2a378468.png";